import React from "react";
export default () => (
  <span style={{ background: "transparent" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
);
